import { Environment, Lightformer, Sky, Stars } from '@react-three/drei'
import { Suspense } from 'react'
import { useVerandaSelector } from '../..'
import { House } from './static/House'
import { StaticPlanes } from './StaticPlanes'
import { useMeasures } from '../../hooks/state/useMeasures'

export const StaticScene = (): JSX.Element => {
  return (
    <group name="staticScene">
      <Suspense fallback={null}>
        <VerandaEnvironment></VerandaEnvironment>
      </Suspense>
      <Suspense fallback={<StaticPlanes />}>
        <House />
      </Suspense>
    </group>
  )
}

const VerandaEnvironment = () => {
  const { forbiddenTypAmount } = useMeasures()
  let nightMode = useVerandaSelector((state) => state.scene.nightMode)
  nightMode = forbiddenTypAmount ? nightMode : false
  return (
    <>
      <Environment frames={1} resolution={256} background blur={1}>
        <Lightformers nightMode={nightMode} />
      </Environment>
      {nightMode && <Stars></Stars>}
      {
        <Sky
          rayleigh={nightMode ? 0.018 : undefined}
          sunPosition={nightMode ? [20, -1.15, 20] : [100, 20, 100]}
        />
      }
    </>
  )
}

function Lightformers({
  positions = [2, 0, 2, 0, 2, 0, 2, 0],
  nightMode = false,
}) {
  return (
    <>
      {/* Ceiling */}
      <Lightformer
        form="circle"
        intensity={nightMode ? 0.08 : 0.75}
        target={[0, 0, 0]}
        position={[0, 10, 0]}
        scale={[50, 50, 1]}
      />
      {/* Sides */}
      <Lightformer
        intensity={nightMode ? 0 : 1.5}
        target={[0, 0, 0]}
        position={[5, 1, -1]}
        scale={[20, 0.5, 1]}
      />
      <Lightformer
        intensity={nightMode ? 0 : 1.5}
        target={[0, 0, 0]}
        position={[-5, 1, -1]}
        scale={[20, 0.5, 1]}
      />
    </>
  )
}
